import PropTypes from "prop-types";
import { Container } from "@mui/material";

// Importar el componente de tarjeta que creamos
import CardComunicaciones from "./cardComunicaciones";

const ContainerResumen = ({ proceso, onProcesoChange }) => {
  return (
    <Container>
      {proceso ? <CardComunicaciones proceso={proceso} onProcesoChange={onProcesoChange} /> : null}
    </Container>
  );
};

ContainerResumen.propTypes = {
  proceso: PropTypes.shape({
    identificador: PropTypes.string.isRequired,
    deudas: PropTypes.array,
    bienes: PropTypes.array,
    adicionales: PropTypes.array,
    finanzas: PropTypes.object,
    propuesta_pago: PropTypes.object,
    documentos: PropTypes.array,
  }),
  onProcesoChange: PropTypes.func,
};

export default ContainerResumen;
